import './social-network-qualification-tab-actions.ajscss';

import { ISocialNetworkActionsService } from '@agent/agent-interface/contact-view/social-network/services/social-network-actions.service';
import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IContact } from '@commons/models/contact';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';

import { BookingFacade, Qualification } from '@contact/upgrade';

import templateUrl from './social-network-qualification-tab-actions.template.html';

const MODULE_NAME = 'socialNetworkQualificationTabActions';

class SocialNetworkQualificationTabActionsCtrl implements IComponentController {
  public name = MODULE_NAME;
  public activeTab: string;
  public socialNetworkTab: string = 'social-network';
  public qualificationTab: string = 'qualificationDeprecatedService';
  contact: IContact;
  qualification: Qualification | undefined;

  constructor(
    public readonly $i18next: i18n,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly socialNetworkFrameService: ISocialNetworkFrameService,
    protected readonly socialNetworkActionsService: ISocialNetworkActionsService,
    private readonly contactFacade: BookingFacade
  ) {}

  $onInit(): void {
    if (this.socialNetworkFrameService.activeSocialNetwork) {
      this.contactDeprecatedService.getContact(this.socialNetworkFrameService.activeSocialNetwork.responseId).then(contact => {
        this.contact = contact;
      });
      this.contactFacade.selectedQualif$.pipe(ng1Destroy(this)).subscribe(qualification => (this.qualification = qualification));
    }
    this.goToSocialNetworkFrame();
  }

  goToSocialNetworkFrame(): void {
    this.activeTab = this.socialNetworkTab;
    this.synchronizeActiveSocialNetwork();
    if (this.contact != null && this.contact.responseId != null) {
      this.socialNetworkFrameService.show(this.contact.responseId);
    }
  }

  goToQualification(): void {
    this.activeTab = this.qualificationTab;
    if (this.contact != null && this.contact.responseId != null) {
      this.socialNetworkFrameService.hide(this.contact.responseId);
    }
    this.synchronizeActiveSocialNetwork();
  }

  isSocialNetworkSelected(): boolean {
    return this.activeTab === this.socialNetworkTab;
  }

  isQualificationSelected(): boolean {
    return this.activeTab === this.qualificationTab;
  }

  private synchronizeActiveSocialNetwork(): void {
    if (this.socialNetworkFrameService.activeSocialNetwork) {
      this.socialNetworkFrameService.activeSocialNetwork.socialNetworkTabState = this.activeTab;
    }
  }

  public isPostTreatmentEnabled(): boolean {
    return !!this.qualification && this.qualification.displayForm;
  }

  public showActions(): boolean {
    if (this.qualification) {
      return (
        !!this.socialNetworkFrameService.activeSocialNetwork && !this.socialNetworkFrameService.activeSocialNetwork.inPostTreatmentMode
      );
    } else {
      return false;
    }
  }
}

export class SocialNetworkQualificationTabActions implements IComponentOptions {
  templateUrl = templateUrl;
  controller = [
    '$i18next',
    'contactDeprecatedService',
    'socialNetworkFrameService',
    'socialNetworkActionsService',
    'contactFacade',
    SocialNetworkQualificationTabActionsCtrl,
  ];
}

export default MODULE_NAME;
